import { IPetDataInputForm } from "../../services/create-appointment-v2/create-appointment-v2.interface";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { actionTypes } from "./createAppointment.actions";

export interface AppointmentFormSchemaType {
  time: string,
  location: string,
  resourcesId: string,
  month?:string,
  day?: string,
  selectedSlotLabel?:string
}
export interface ICreateAppointmentState {
  selectedPets: IPetItemResponse[];
  appointmentForm: AppointmentFormSchemaType | null;
  reasonForVisit: { [key: string]: IPetDataInputForm };
  promoCode?: string[];
  currentStep: number;
}

const initialState: ICreateAppointmentState = {
  selectedPets: [],
  appointmentForm: null,
  reasonForVisit: {},
  promoCode: [],
  currentStep: 0,
};

export const createAppointmentReducer = (
  state: ICreateAppointmentState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_PETS_SELECTED:
    return {
      ...state,
      selectedPets: action.payload,
    };
  case actionTypes.SET_FIND_AVAILABILITY_FORM:
    return {
      ...state,
      appointmentForm: action.payload,
    };
  case actionTypes.SET_REASON_FOR_VISIT:
    return {
      ...state,
      reasonForVisit: action.payload,
    };
  case actionTypes.SET_PROMO_CODE:
    return {
      ...state,
      promoCode: action.payload,
    };
  case actionTypes.SET_CURRENT_STEP:
    return {
      ...state,
      currentStep: action.payload,
    };
  default:
    return state;
  }
};
